"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTACHMENT_STATUS = void 0;
exports.ATTACHMENT_STATUS = {
    INITIALIZED: 'initialized',
    UPLOAD_URL_GENERATED: 'upload_url_generated',
    UPLOADED: 'uploaded',
    ATTACHED: 'attached',
};
//# sourceMappingURL=attachment.types.js.map